let initialized = false;
const firedPurchases = new Set();
// Events fired before the pixel finishes initialising (config fetch + script load)
// would otherwise be silently dropped — e.g. ViewContent on a cold ad-click landing.
const pending = [];

export const initPixel = (pixelId) => {
  if (!pixelId || initialized || typeof window === "undefined") return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(t);
  window.fbq("init", pixelId);
  initialized = true;
  while (pending.length) {
    const [eventName, params, eventId] = pending.shift();
    track(eventName, params, eventId);
  }
};

export const track = (eventName, params = {}, eventId) => {
  if (typeof window === "undefined") return;
  if (!window.fbq) {
    if (pending.length < 50) pending.push([eventName, params, eventId]);
    return;
  }
  if (eventId) window.fbq("track", eventName, params, { eventID: eventId });
  else window.fbq("track", eventName, params);
};

export const trackPurchase = (order) => {
  if (!window.fbq || !order?.id) return;
  const eventId = `purchase_${order.id}`;
  if (firedPurchases.has(eventId)) return;
  firedPurchases.add(eventId);
  track(
    "Purchase",
    {
      value: order.total,
      currency: "INR",
      content_ids: order.items.map((i) => i.sku),
      content_type: "product",
      num_items: order.items.reduce((a, i) => a + i.qty, 0),
      contents: order.items.map((i) => ({ id: i.sku, quantity: i.qty, item_price: i.price })),
    },
    eventId
  );
};

export const getCookie = (name) =>
  document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=") || null;

export const pixelCookies = () => ({ fbp: getCookie("_fbp"), fbc: getCookie("_fbc") });
